import React, { useState, useEffect } from "react";
import {
  TextArea,
  Dropdown,
  Input,
  Form,
  Button,
  Divider,
  Dimmer,
  Loader,
  Image,
} from "semantic-ui-react";
import * as auth from "../../modules/Auth/_redux/authRedux";
import location_icon from "../../../Assets/Icons/location_on.jpg";
import sub_location_icon from "../../../Assets/Icons/pin_drop.png";
import calendar_icon from "../../../Assets/Icons/calender-icon.svg";
import { PhoneInput } from "react-international-phone";
import { Country, State } from "country-state-city";
import { connect, useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { selectTranslations } from "../../config/i18n/slice";
import { scrollToError } from "../../../utilFunctions/scrollToError";
import { useDropzone } from "react-dropzone";
import {
  AddIcon,
  AddIconWithCircle,
  BillingInfoIcon,
  CloseIcon,
  ContactInfoIcon,
  DeleteIcon,
  EditWhiteIcon,
  ImgPhotos,
  InfoIcon,
  InfoIconBlue,
  TextSnippet,
} from "../../../Assets/Icons/svg";
import Asterisk from "../../components/common/Asterisk";
import DatePicker from "react-multi-date-picker";
import { format } from "date-fns";
import ToolTip from "react-power-tooltip";
import { fetchVendorInitData } from "../../../redux/reducers/vendorReducer";
import { Resizable } from "re-resizable";
import useNewCancelModal from "../../../hooks/Messages/useNewCncelModal";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import AddLocation from "../Locations/add";
import ImageCrop from "../MyCompanyProfile/ImageCrop";
import { createNewVendor } from "../../config/api/vendorApis";
import { getAllParentLocations } from "../../config/sharedApi/locationApis";
import {
  handleKeyDown,
} from "../../config/common/commonFunctions";
import { uploadFile } from "../../config/api/configApis";
import { currencies } from "../../config/common/commonVariables";
import { getUserData } from "../../config/sharedApi/peopleApis";
import {
  buildValidation,
  makeOnBlurFactory,
  makeOnValuesChangeFactory,
  makeValidateOnSubmitFactory,
  isPhoneValid,
} from "./VendorsValidationRules";

const FileUpload = ({
  onFileChange,
  name = "",
  attachments = {},
  setAttachments = () => {},
  setImageSrc = () => {},
  setFile = () => {},
  setPersonalImgId = () => {},
}) => {
  const fileTypes = {
    images: [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/svg+xml",
      "image/webp",
      "image/heic",
    ],
    documents: [
      "text/plain",
      "application/pdf",
      "text/csv",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ],
    video: ["video/mp4", "video/quicktime", "video/webm", "video/hevc"],
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: (acceptedFiles) => {
      const allowedFileTypes = [...fileTypes.images];


      const invalidFiles = acceptedFiles.filter(
        (file) => !allowedFileTypes.includes(file.type)
      );


      if (invalidFiles?.length > 0) {
        toast.error(t.common.invalid_msg);
        return;
      }

      let totalSize = organisationImage?.attachmentsSize
        ? organisationImage?.attachmentsSize
        : 200;
      const validFiles = acceptedFiles.filter((file) => {
        const isImage = fileTypes.images.includes(file.type);
        const isDocument = fileTypes.documents.includes(file.type);

        const isVideo = fileTypes.video.includes(file.type);

        const validSize =
          (isVideo || isImage || isDocument) &&
          file.size < totalSize * 1024 * 1024;

        if (!validSize) {
          toast.error(
            `${t.common.file_upload_valid} ${totalSize} ${t.common.file_upload_second}`
          );
          return false;
        }
        return true;
      });

      onFileChange(validFiles, name);
    },
  });
  const t = useSelector(selectTranslations);
  const organisationImage = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation;
    } else {
      return null;
    }
  });

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });
  //TO DO : Customize and Style this Drag and Drop to Upload box as you want🧑‍💻😊
  return (
    <div {...getRootProps()}>
      <input {...getInputProps()} />
      {name === "image" ? (
        attachments?.image?.name ? (
          <div className="user-img-avatar position-relative">
            <Image
              avatar
              title={attachments?.image?.name}
              src={`${attachments?.image?.url}`}

            ></Image>
            <span
              className={`people-circle-image ${
                selectedLanguage == "en" ? "" : "rtl-people"
              }`}
            >
              <span
                className={`edit-container ${
                  selectedLanguage == "en" ? "" : "rtl-edit"
                }`}
              >
                <EditWhiteIcon /> {t.common.edit}
              </span>
            </span>

            <span
              className="ml-3 mr-3 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setPersonalImgId(null);
                setFile("");
                setImageSrc("");
                setAttachments({
                  ...attachments,
                  image: null,
                });
              }}
            >
              <DeleteIcon />
            </span>
          </div>
        ) : (
          <div className="image-dropzone  text-center mb-5">
            <div>
              <p className="p1">
                <div className="d-flex align-items-start justify-content-center ">
                  <div>
                    {" "}
                    <ImgPhotos />
                  </div>
                  <div
                    className={`mr-2 ml-2 ${
                      selectedLanguage == "en" ? "text-left" : "text-right"
                    }`}
                  >
                    {" "}
                    <div className="blue-text">
                      {" "}
                      {t.common.upload_img}
                    </div>{" "}
                    <p
                     className="mb-0 files-text"

                    >
                      {" "}
                      {t.common.valid_files_img}
                    </p>{" "}
                  </div>
                </div>
              </p>
            </div>
          </div>
        )
      ) : attachments?.warrantyFile?.name ? (
        <div className="warrenty-file-dropzone text-center">
          <label>
            {attachments?.warrantyFile?.name}
            <span
              className="ml-3 mr-3 c-pointer"
              onClick={(e) => {
                e.stopPropagation();
                setAttachments({
                  ...attachments,
                  warrantyFile: null,
                });
              }}
            >
              <DeleteIcon />
            </span>
          </label>
        </div>
      ) : (
        <div className="warrenty-file-dropzone d-flex align-items-center justify-content-between">
          <div className="d-flex ml-4 mr-4">
            <TextSnippet />
            <div className="pl-4 pr-4">
              <p className="p1 m-0">Warranty file</p>
              <p className="p2 m-0">Attach a file to this asset</p>
            </div>
          </div>
          <div>
            <AddIconWithCircle />
          </div>
        </div>
      )}
    </div>
  );
};
function Add(props) {
  const {
    toggled,
    untoggle,
    refresh,
    setRefresh,
    setFilterOptions,
    setSearchTitle,
    role,
    allIds,
    setAllIds,
    setToggleAddModal,
  } = props;
  const t = useSelector(selectTranslations);
  const { userPermissions } = usePermissionsSimplified();
  const { setNewCancelModal, NewCancelModal } = useNewCancelModal();
  const dispatch = useDispatch();
  const { initData } = useSelector((state) => ({
    initData: state.vendor.vendorInitData,
  }));
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });

  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const [personalImgId, setPersonalImgId] = useState();
  const [imageSrc, setImageSrc] = useState("");
  const [file, setFile] = useState(""); //
  const currentUserId = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.id;
    } else {
      return null;
    }
  });

  const user = useSelector((state) => {
    if (state?.auth?.user) {
      return state.auth.user;
    } else {
      return null;
    }
  });
  const [phone, setPhone] = useState(false);
  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });
  const [initChange, setInitChange] = useState(false);
  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const [activePane, setActivePane] = useState(0);
  const [buttonStatus, setButtonStatus] = useState(0);
  const [responseData, setResponseData] = useState({});
  const [showTeamsTooltip, setTeamsTooltip] = useState(false);
  const [showCancleTooltip, setCancleTooltip] = useState(false);

  const [attachments, setAttachments] = useState({
    image: null,
  });
  const [options, setOptions] = useState({
    locations: [],
    Industry: [
      {
        key: "industry1",
        value: "Commercial Real Estate Companies",
        text: t.customers.industry.commercial,
      },
      {
        key: "industry2",
        value: "Corporate Offices",
        text: t.customers.industry.corporate,
      },
      {
        key: "industry3",
        value: "Manufacturing Companies",
        text: t.customers.industry.manufacturing,
      },
      {
        key: "industry4",
        value: "Healthcare Organizations",
        text: t.customers.industry.healthcare,
      },
      {
        key: "industry5",
        value: "Educational Institutions",
        text: t.customers.industry.educational,
      },
      {
        key: "industry6",
        value: "Government and Public Sector Organizations",
        text: t.customers.industry.government,
      },
      {
        key: "industry7",
        value: "Hospitality and Entertainment Companies",
        text: t.customers.industry.hospitality,
      },
      {
        key: "industry8",
        value: "Data Centers",
        text: t.customers.industry.data_centers,
      },
      {
        key: "industry9",
        value: "Retail Companies",
        text: t.customers.industry.retails,
      },
      {
        key: "industry10",
        value: "Sports and Recreation Facilities",
        text: t.customers.industry.sports,
      },
    ],
    preferences: [
      {
        key: "1",
        value: "English",
        text: "English",
      },
      {
        key: "2",
        value: "العربية",
        text: "العربية",
      },
    ],

    Mode: [
      {
        key: "1",
        value: "cash",
        text: t.vendors.mode.cash,
      },
      {
        key: "2",
        value: "credit card",
        text: t.vendors.mode.credit_card,
      },
      {
        key: "3",
        value: "bank transfer",
        text: t.vendors.mode.bank,
      },
      {
        key: "4",
        value: "procurement card",
        text: t.vendors.mode.procurement_card,
      },
      {
        key: "5",
        value: "check",
        text: t.vendors.mode.check,
      },
      {
        key: "6",
        value: "cliq",
        text: t.vendors.mode.cliq,
      },
    ],
    accountType: [
      {
        key: "0",
        value: "salaries account",
        text: t.vendors.account.salary,
      },
      {
        key: "1",
        value: "basic bank account",
        text: t.vendors.account.basic,
      },
      {
        key: "2",
        value: "time deposit account",
        text: t.vendors.account.time_deposit,
      },
      {
        key: "3",
        value: "current account",
        text: t.vendors.account.current,
      },
      {
        key: "4",
        value: "time deposit with prizes",
        text: t.vendors.account.time_deposit_price,
      },
      {
        key: "5",
        value: "POS current account",
        text: t.vendors.account.pos,
      },
    ],
  });

  const fetchLocationsOptions = async (updatedAllIds = []) => {
    setOptions({
      ...options,
      locations: [],
    });

    let finalIds = [...allIds];

    if (updatedAllIds?.length > 0) {
      finalIds = [...updatedAllIds];
    }
    const fetchData = await getAllParentLocations(
      organisationId,
      "",
      1,
      99999,
      [],
      [],
      [],
      ["name:asc"]
    );
    let the_options = [];
    let parentOptions = [];
    let subOptions = [];
    if (fetchData?.response?.length > 0) {
      fetchData.response.forEach((el) => {
        if (!(role === "super_admin")) {

          if (finalIds?.includes(el.id)) {

            parentOptions.push({
              key: el.id,
              value: el.id,
              text: el.attributes.name,
              image: { src: location_icon },
              className: "main-location-dropdown-option",
              disabled: false,
            });


            if (el?.attributes?.subLocations?.data?.length > 0) {
              el.attributes.subLocations.data.forEach((subEl) => {
                if (finalIds?.includes(subEl.id)) {
                  subOptions.push({
                    key: subEl.id,
                    value: subEl.id,
                    text: subEl.attributes.name,
                    image: { src: sub_location_icon },
                    className: "sub-location-dropdown-option",
                    parentId: el.id,
                  });
                }
              });
            }
          } else {

            const hasMatchingSubLocation = el?.attributes?.subLocations?.data?.some(
              (subEl) => finalIds?.includes(subEl.id)
            );

            if (hasMatchingSubLocation) {

              parentOptions.push({
                key: el.id,
                value: el.id,
                text: el.attributes.name,
                image: { src: location_icon },
                className: "main-location-dropdown-option",
                disabled: true,
              });

              // Collect matching sub-options
              el?.attributes?.subLocations?.data?.length > 0 &&
                el.attributes.subLocations.data.forEach((subEl) => {
                  if (finalIds?.includes(subEl.id)) {
                    subOptions.push({
                      key: subEl.id,
                      value: subEl.id,
                      text: subEl.attributes.name,
                      image: { src: sub_location_icon },
                      className: "sub-location-dropdown-option",
                      parentId: el.id,
                    });
                  }
                });
            }
          }
        } else {

          parentOptions.push({
            key: el.id,
            value: el.id,
            text: el.attributes.name,
            image: { src: location_icon },
            className: "main-location-dropdown-option",
          });


          if (el?.attributes?.subLocations?.data?.length > 0) {
            el.attributes.subLocations.data.forEach((subEl) => {
              subOptions.push({
                key: subEl.id,
                value: subEl.id,
                text: subEl.attributes.name,
                image: { src: sub_location_icon },
                className: "sub-location-dropdown-option",
                parentId: el.id,
              });
            });
          }
        }
      });


      subOptions.sort((a, b) => a.text.localeCompare(b.text));


      parentOptions.forEach((parentOption) => {
        the_options.push(parentOption);

        subOptions.forEach((subOption) => {
          if (subOption.parentId === parentOption.key) {
            the_options.push(subOption);
          }
        });
      });


      setOptions((prev) => ({
        ...prev,
        locations: the_options,
      }));

      return the_options;
    }
  };

  const [cancelModal, toggleCancelModal] = useState(false);
  const [successModal, toggleSuccessModal] = useState(false);
  const [customerData, setCustomerData] = useState({
    startDate: "",
    preferences: "English",
    endDate: "",
    credit_days: "",
    pre_process_days: "",
    name: "",
    address: "",
    location: "",
    countryCode: "962",
    contact_name: "",
    contact_phone: "",
    contact_email: "",
    isSame: false,
    phone: "",
    website: "",
    email: "",
    serviceType: "",
    description: "",
    countries_options: [],
    country: "",
    cities_options: [],
    city: "",
    billing_name: "",
    billing_postal_code: "",
    billing_address: "",
    billing_addressLine2: "",
    billing_addressLine3: "",
    billing_rate: 0,
    billing_currency: "JOD",
    Industry: "",
    mode: "",
    bank: "",
    account_no: "",
    account_type: "",
    IBAN: "",
    disbursement_currency: "JOD",
  });

  const [validation, setValidation] = useState(() => buildValidation(t));

  const getCustomerData = () => customerData;

  const makeOnBlur = makeOnBlurFactory({ getCustomerData, setValidation, t });
  const onValuesChange = makeOnValuesChangeFactory({
    getCustomerData,
    setCustomerData,
    setValidation,
    t,
  });
  const validateOnSubmit = makeValidateOnSubmitFactory({
    getCustomerData,
    validation,
    setValidation,
    t,
  });

  const resetForm = () => {
    setCustomerData({
      startDate: "",
      preferences: "English",
      endDate: "",
      credit_days: "",
      pre_process_days: "",
      name: "",
      location: "",
      address: "",
      countryCode: "962",
      isSame: false,
      contact_name: "",
      contact_phone: "",
      contact_email: "",
      phone: "",
      website: "",
      email: "",
      serviceType: "",
      description: "",
      countries_options: [],
      country: "",
      cities_options: [],
      city: "",
      billing_name: "",
      billing_postal_code: "",
      billing_address: "",
      billing_addressLine2: "",
      billing_addressLine3: "",
      billing_rate: 0,
      billing_currency: "JOD",
      Industry: "",
      mode: "",
      bank: "",
      account_no: "",
      account_type: "",
      IBAN: "",
      disbursement_currency: "JOD",
    });
    setValidation(buildValidation(t));
    setInitChange(false);
    setFile("");
    setImageSrc("");
    setPersonalImgId(null);
    setAttachments({
      image: null,
    });
    setActivePane(0);
    setModalWidth(Math.max(window.innerWidth / 2, 514));
  };
  const onFileChange = (files, name) => {
    setInitChange(true);
    const reader = new FileReader();
    reader.addEventListener("load", () => {
      setImageSrc(reader.result);
    });
    reader.readAsDataURL(files[0]);

    setFile({
      name: files[0]?.name,
      type: files[0]?.type,
    });
  };

  useEffect(() => {
    if (toggled) {
      const countries = Country.getAllCountries();
      if (countries) {
        const _g_options = countries.map((el) => {
          return {
            key: el?.isoCode?.toLowerCase(),
            value: el?.isoCode,
            text: el.name,
            flag: el?.isoCode?.toLowerCase(),
          };
        });
        setCustomerData((pre) => ({ ...pre, countries_options: _g_options }));
        fetchLocationsOptions();
      }
    }
  }, [toggled]);

  const fetchCities = (code) => {
    const fetchData = State.getStatesOfCountry(code);

    if (fetchData.length > 0) {
      let the_options = fetchData.map((el) => {
        return {
          key: el.isoCode,
          value: el.isoCode,
          text: el.name,
        };
      });
      setCustomerData({
        ...customerData,
        country: code,
        cities_options: the_options,
      });
    }
  };

  useEffect(() => {
    const fetchData = State.getStatesOfCountry(customerData.country);

    if (fetchData.length > 0) {

      let the_options = fetchData.map((el) => {
        return {
          key: el.isoCode,
          value: el.isoCode,
          text: el.name,
        };
      });
      setCustomerData({
        ...customerData,
        cities_options: the_options,
      });
    } else {
      setCustomerData({
        ...customerData,
        cities_options: [],
      });
    }
  }, [customerData.country]);

  const createNewCustomerHandler = async () => {
    const hasErrors = validateOnSubmit();
    if (!hasErrors) {
      setButtonStatus(1);

      const prefs = (customerData?.preferences || "english").toLowerCase();

      const billingInformation = {
        name: customerData.billing_name,
        country: customerData?.country ? customerData.country : null,
        city: customerData?.city ? customerData.city : null,
        postalCode: customerData.billing_postal_code,
        address: customerData.billing_address,
        addressLine2: customerData.billing_addressLine2,
        addressLine3: customerData.billing_addressLine3,
        rate: customerData?.billing_rate ? customerData?.billing_rate : null,
        currency: customerData.billing_currency || null,
        preProcessDays: customerData.pre_process_days
          ? Number(customerData.pre_process_days)
          : null,
        paymentDetails: {
          mode: customerData?.mode ? customerData?.mode : null,
          bank: customerData?.bank,
          accountType: customerData?.account_type
            ? customerData?.account_type
            : null,
          accountNo: customerData?.account_no
            ? Number(customerData?.account_no)
            : null,
          IBAN: customerData?.IBAN ? Number(customerData?.IBAN) : null,
          disbursementCurrency: customerData?.disbursement_currency,
        },
      };
      const contactInformation = {
        name: customerData.contact_name,
        phone: customerData?.contact_phone ? customerData?.contact_phone : null,
        email: customerData?.contact_email ? customerData.contact_email : null,
      };

      const response = await createNewVendor(
        customerData.name,
        customerData.address,
        customerData?.phone ? customerData.phone : null,
        customerData.website,
        customerData?.email ? customerData.email : null,
        customerData.serviceType,
        customerData.description,
        billingInformation,
        personalImgId,
        organisationId,
        currentUserId,
        customerData.Industry || null,
        contactInformation,
        Number(customerData.credit_days),
        customerData?.startDate ? customerData.startDate : null,
        customerData?.endDate ? customerData.endDate : null,
        customerData?.location ? customerData.location : null,
        prefs
      );

      if (response.status == 200) {
        setButtonStatus(0);
        untoggle();
        resetForm();
        setFilterOptions({
          locations: [],
          cities: [],
        });
        setSearchTitle("");

        setResponseData({
          name: response.data.name,
        });

        toast.success(t.vendors.vendor + " " + t.common.added_success);

        if (initData?.length == 0) {
          const fetchData = await dispatch(
            fetchVendorInitData({ organisationId, role, allIds })
          );
        }
      } else if (response.status == 400) {
        if (response.error && response.error.message) {
          toast.error(response.error.message);
        } else {
          toast.error(t.common.something_wrong);
          untoggle();
          resetForm();
        }
      }
      setButtonStatus(0);
    } else {
      scrollToError();
    }
  };

  const changeTab = async (tab, errors, setFieldTouched, values) => {
    const hasErrors = validateOnSubmit();
    if (!hasErrors) {
      setActivePane(tab);
      return;
    } else {
      scrollToError();
    }
  };

  const cancelHandler = () => {
    resetForm();
    setModalWidth(Math.max(window.innerWidth / 2, 514));
    untoggle();
    setNewCancelModal(false);
    setInitChange(false);
  };
  return (
    <>
      <div
        clearing
        style={{ maxWidth: `${modalWidth}px` }}
        className={
          toggled
            ? "aside-modal preview active procedure"
            : "aside-modal preview procedure"
        }
      >
        <Resizable
          size={{ width: modalWidth, height: "auto" }}
          minWidth={"514px"}
          onResize={(e, direction, ref, d) => {
            setModalWidth(ref.offsetWidth);
          }}
        >
          <div className="modal-header">
            <div className="flexbox justify-between align-center">
              <div className="name">{t.vendors.form.add_vendor}</div>

              <div className="flexbox align-center workorder-header-buttons">
                <span
                  className="position-relative procedure-header-button c-pointer"
                  onMouseOver={() => setCancleTooltip(true)}
                  onMouseLeave={() => setCancleTooltip(false)}
                  onClick={() =>
                    initChange ? setNewCancelModal(true) : cancelHandler()
                  }
                >
                  <CloseIcon />
                  <ToolTip
                    color="#fff"
                    backgroundColor="#172B4D"
                    position={
                      selectedLanguage == "en"
                        ? "bottom center"
                        : "bottom center"
                    }
                    arrowAlign="center"
                    show={showCancleTooltip}
                    textBoxWidth="36px"
                    padding="5px 5px 5px 7px"
                    borderRadius="5px"
                    static
                  >
                    <span className="work-order-preview-tooltip">
                      {t.common.close}
                    </span>
                  </ToolTip>
                </span>
              </div>
            </div>
          </div>
          <div
            className="body p-6"

          >
            {buttonStatus == 1 ? (
              <Dimmer active inverted>
                <Loader inverted content={t.common.loading} />
              </Dimmer>
            ) : (
              ""
            )}
            <Button.Group
              className="add-people-btn vendor mt-5"
              basic
              fluid

              size="medium"
            >
              <Button
                active={activePane == 0}
                onClick={() => changeTab(0)}
                type="button"
              >
                {t.vendors.table.vendor_info}
              </Button>

              <Button
                className="add-people-tab"
                active={activePane == 1}
                onClick={() => changeTab(1)}
                type="button"
              >
                {t.customers.form.billing_information}
              </Button>
            </Button.Group>
            <Divider className="mt-0 vendor-divider" />

            <div>
            <div className={activePane === 0 ? "d-block" : "d-none"}>
                <FileUpload
                  onFileChange={onFileChange}
                  name="image"
                  setImageSrc={setImageSrc}
                  setFile={setFile}
                  attachments={attachments}
                  setAttachments={setAttachments}
                />

                {imageSrc && (
                  <ImageCrop
                    src={imageSrc}
                    minWidth={20}
                    minHeight={20}
                    fileData={file}
                    onAccept={async (croppedImageUrl) => {
                      let CroppedFile = new File([croppedImageUrl], file.name, {
                        type: file.type,
                      });

                      var randomnumber =
                        Math.floor(Math.random() * (0 - 100 + 1)) + 100;

                      const personalPictureResponse = await uploadFile([
                        CroppedFile,
                      ]);

                      if (personalPictureResponse?.status == 200) {
                        let fileData = personalPictureResponse?.data[0]?.url;
                        setPersonalImgId(personalPictureResponse.data[0].id);
                        setImageSrc("");
                        setFile("");
                        setAttachments({
                          ...attachments,
                          ["image"]: {
                            file: CroppedFile,
                            id: randomnumber,
                            name: CroppedFile.name,
                            type: CroppedFile.type,
                            cancelPopup: false,
                            isChanged: true,
                            url: fileData ? fileData : null,
                          },
                        });
                      } else {
                        toast.error(t.common.something_wrong);
                      }
                    }}
                    onCancel={() => {
                      setImageSrc("");
                      setFile("");
                    }}
                  />
                )}

                <Form.Field>
                  <label className="label-item mt-3">
                    {t.vendors.table.name}
                    <Asterisk color="#172B4D" />
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_name}
                    value={customerData.name}
                    onChange={onValuesChange("name")}
                    error={validation.name.error && validation.name.skipped}
                    onBlur={makeOnBlur("name")}
                  />
                  {validation.name.error && validation.name.skipped ? (
                    <div className="label-error">{validation.name.message}</div>
                  ) : (
                    ""
                  )}
                </Form.Field>

              <Form className="text-area-container">
                  <Form.Field>
                    <label className="label-item">
                      {t.customers.form.description}
                    </label>
                    <TextArea
                      autoComplete="new-password"
                      value={customerData.description}
                      onChange={onValuesChange("description")}
                      rows={4}
                      fluid
                      placeholder={t.customers.form.add_description}
                      error={validation.description.error && validation.description.skipped}
                      onBlur={makeOnBlur("description")}
                    />
                    {validation.description.error && validation.description.skipped ? (
                        <div className="label-error">{validation.description.message}</div>
                    ) : (
                        ""
                    )}
                  </Form.Field>
                </Form>

                <Form.Field>
                  <label className="label-item mt-7">
                    {t.customers.form.location}<Asterisk color="#172B4D" />{" "}
                    <span
                      className="position-relative c-pointer"
                      onMouseOver={() => setTeamsTooltip(true)}
                      onMouseLeave={() => setTeamsTooltip(false)}
                    >
                      {showTeamsTooltip ? (
                        <>
                          <InfoIconBlue />
                          <ToolTip
                            color="#fff"
                            backgroundColor="#172B4D"
                            position={
                              selectedLanguage == "ar"
                                ? "left top"
                                : "right top"
                            }
                            show={showTeamsTooltip}
                            textBoxWidth="100px"
                            arrowAlign="center"
                            fontSize="9px"
                            fontWeight="400"
                            fontFamily={
                              selectedLanguage == "ar"
                                ? "Noto Kufi Arabic"
                                : "Roboto"
                            }
                            padding="4px 14px 4px 7px"
                            lineHeight="16px"
                            borderRadius="6px"
                            static
                            moveDown="0px"
                          >
                            <span className="work-order-preview-tooltip parts">
                              {t.customers.form.served}
                            </span>
                          </ToolTip>
                        </>
                      ) : (
                        <InfoIcon />
                      )}
                    </span>
                  </label>
                  <div className="flexbox">
                    <Dropdown
                      placeholder={t.customers.form.add_location}
                      fluid
                      className="loc-dropdown"
                      selection
                      clearable
                      error={
                        validation.location.error && validation.location.skipped
                      }
                          onBlur={(e) => {
                        if (
                          validation.location.pattern(customerData.location)
                        ) {
                          setValidation({
                            ...validation,
                            location: {
                              ...validation.location,
                              error: false,
                              skipped: true,
                            },
                          });
                        } else {
                          setValidation({
                            ...validation,
                            location: {
                              ...validation.location,
                              error: true,
                              skipped: true,
                            },
                          });
                        }
                      }}
                      noResultsMessage={t.common.no_results_found}
                      search
                      options={options.locations}
                      value={customerData.location}
                      onChange={onValuesChange("location")}
                    />
                    {userPermissions?.location?.create &&
                    userPermissions?.location?.view ? (
                      <span
                        className="add-location ml-2 mr-2 p-1 d-flex align-items-center justify-content-center c-pointer"
                        onClick={() => {
                          setToggleAsideModal(true);
                          setToggleAddModal(false);
                        }}

                      >
                        <AddIcon />
                      </span>
                    ) : null}{" "}
                  </div>
                   {validation.location.error && validation.location.skipped ? (
                    <div className="label-error">
                      {validation.location.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {" "}
                    {t.customers.form.phone}
                    <Asterisk color="#172B4D" />
                  </label>
                  <PhoneInput
                    defaultCountry={"jo"}
                    value={customerData.phone}
                    placeholder={t.customers.form.add_number}
                    onChange={(value) => {
                      if (!phone) {
                        setPhone(true);
                        return;
                      }
                      setCustomerData({
                        ...customerData,
                        phone: value || "",
                      });
                      if (customerData.isSame) {
                        setCustomerData({
                          ...customerData,
                          phone: value || "",
                          contact_phone: value || "",
                        });
                      }
                      if (!value) {
                        setValidation({
                          ...validation,
                          phone: {
                            ...validation.phone,
                            error: false,
                            skipped: false,
                            message: t.common.required_field,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          phone: {
                            ...validation.phone,
                            error: false,
                            skipped: true,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && !isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          phone: {
                            ...validation.phone,
                            error: true,
                            skipped: true,
                            message: t.customers.form.invalid_phone,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      }
                    }}
                    error={
                      validation?.phone?.error && validation?.phone?.skipped
                    }
                  />
                  {validation?.phone?.error && validation?.phone?.skipped ? (
                    <div className="label-error">
                      {validation?.phone?.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.form.email}
                    <Asterisk color="#172B4D" />
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_email}
                    value={customerData.email}
                    onChange={onValuesChange("email")}
                    className="email-password-ltr"
                    error={validation.email.error && validation.email.skipped}
                    onBlur={makeOnBlur("email")}
                  />
                  {validation.email.error && validation.email.skipped ? (
                    <div className="label-error">
                      {validation.email.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.form.website}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_website}
                    value={customerData.website}
                    error={validation.website.error && validation.website.skipped}
                    onBlur={makeOnBlur("website")}
                    onChange={onValuesChange("website")}
                  />
                  {validation.website.error && validation.website.skipped ? (
                      <div className="label-error">
                        {validation.website.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.form.service_type}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_service_type}
                    value={customerData.serviceType}
                    error={validation.serviceType.error && validation.serviceType.skipped}
                    onBlur={makeOnBlur("serviceType")}
                    onChange={onValuesChange("serviceType")}
                  />
                  {validation.serviceType.error && validation.serviceType.skipped ? (
                      <div className="label-error">
                        {validation.serviceType.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.common.industry}
                    <Asterisk color="#172B4D" />
                  </label>
                  <Dropdown
                    placeholder={t.customers.form.add_industry}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    clearable
                    selection
                    search
                    options={options.Industry}
                    value={customerData.Industry}
                    error={validation.industry.error && validation.industry.skipped}
                    onBlur={makeOnBlur("industry", (cd) => cd.Industry)}
                    onChange={onValuesChange("Industry")}
                  />
                  {validation.industry.error && validation.industry.skipped ? (
                      <div className="label-error">
                        {validation.industry.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.vendors.form.credit_days}
                    <Asterisk color="#172B4D" />
                  </label>
                  <div className="estimation-time-div">
                    <Input
                      type="number"
                      onKeyDown={(evt) => handleKeyDown(evt)}
                      min="0"
                      fluid
                      placeholder={t.vendors.form.add_credit_days}
                      value={customerData.credit_days}
                      error={validation.credit_days.error && validation.credit_days.skipped}
                      onBlur={makeOnBlur("credit_days")}
                      onChange={onValuesChange("credit_days")}
                    ></Input>
                  </div>
                  {validation.credit_days.error && validation.credit_days.skipped ? (
                      <div className="label-error">
                        {validation.credit_days.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.vendors.form.start_date}
                  </label>
                  <div className="change-date-time-inll position-relative">
                    <DatePicker

                      value={
                        customerData.startDate
                          ? new Date(customerData.startDate)
                          : null
                      }
                      onChange={(value) => {
                        if (value && value.valueOf()) {
                          setCustomerData({
                            ...customerData,
                            startDate: format(value.valueOf(), "yyyy-MM-dd"),
                            endDate: null,
                          });
                        } else {
                          setCustomerData({
                            ...customerData,
                            startDate: null,
                            endDate: null,
                          });
                        }
                      }}
                      showMonthDropdown
                      showYearDropdown
                      placeholder={t.vendors.form.add_start_date}
                      className={"active"}

                      weekDays={[
                        t.workOrders.details_view.sun,
                        t.workOrders.details_view.mon,
                        t.workOrders.details_view.tue,
                        t.workOrders.details_view.wed,
                        t.workOrders.details_view.thu,
                        t.workOrders.details_view.fri,
                        t.workOrders.details_view.sat,
                      ]}
                      months={[
                        t.common.january,
                        t.common.february,
                        t.common.march,
                        t.common.april,
                        t.common.may,
                        t.common.june,
                        t.common.july,
                        t.common.august,
                        t.common.september,
                        t.common.october,
                        t.common.november,
                        t.common.december,
                      ]}
                      format="DD/MM/YYYY"
                    ></DatePicker>

                    <img
                      className="position-absolute"

                      src={calendar_icon}
                    />
                  </div>
                </Form.Field>
                <Form.Field

                 >
                  <label className="label-item">
                    {t.vendors.form.end_date}
                  </label>
                  <div className="change-date-time-inll position-relative">
                    <DatePicker

                      minDate={new Date(customerData.startDate)}
                      disabled={!customerData?.startDate}
                      value={
                        customerData.endDate && customerData.startDate
                          ? new Date(customerData.endDate)
                          : null
                      }
                      onChange={(value) => {
                        if (
                          value &&
                          value.valueOf() &&
                          customerData.startDate
                        ) {
                          setCustomerData({
                            ...customerData,
                            endDate: format(value.valueOf(), "yyyy-MM-dd"),
                          });
                        } else {
                          setCustomerData({
                            ...customerData,
                            endDate: null,
                          });
                        }
                      }}
                      showMonthDropdown
                      showYearDropdown
                      placeholder={t.vendors.form.add_end_date}
                      className={"active"}
                      weekDays={[
                        t.workOrders.details_view.sun,
                        t.workOrders.details_view.mon,
                        t.workOrders.details_view.tue,
                        t.workOrders.details_view.wed,
                        t.workOrders.details_view.thu,
                        t.workOrders.details_view.fri,
                        t.workOrders.details_view.sat,
                      ]}
                      months={[
                        t.common.january,
                        t.common.february,
                        t.common.march,
                        t.common.april,
                        t.common.may,
                        t.common.june,
                        t.common.july,
                        t.common.august,
                        t.common.september,
                        t.common.october,
                        t.common.november,
                        t.common.december,
                      ]}
                      format="DD/MM/YYYY"
                    ></DatePicker>

                    <img
                      className="position-absolute"

                      src={calendar_icon}
                    />
                  </div>
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-7">
                    {t.customers.form.preferences}
                  </label>
                  <Dropdown
                    placeholder={t.customers.form.add_preferences}
                    fluid
                    selection
                    noResultsMessage={t.common.no_results_found}
                    search
                    options={options.preferences}
                    value={customerData.preferences}
                    onChange={onValuesChange("preferences")}
                  />
                </Form.Field>

                <Divider className="mt-5" />

                <div className="billing-info mt-7  d-flex">
                  <ContactInfoIcon />
                  <p
                    className={`font16 mt-1 required-text ${
                      selectedLanguage == "en" ? "ml-2" : "mr-2"
                    }`}
                  >
                    {t.customers.form.contact_information}
                  </p>
                </div>

                <Form.Field>
                  <label className="label-item mt-8">
                    {t.customers.contact_name}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_contact_name}
                    value={customerData.contact_name}
                    error={validation.contact_name.error && validation.contact_name.skipped}
                    onBlur={makeOnBlur("contact_name")}
                    onChange={onValuesChange("contact_name")}
                  />
                  {validation.contact_name.error && validation.contact_name.skipped ? (
                      <div className="label-error">
                        {validation.contact_name.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.customers.contact_phone}
                  </label>
                  <PhoneInput
                    defaultCountry="jo"
                    value={customerData.contact_phone}
                    placeholder={t.customers.form.add_number}
                    onChange={(value) => {
                      if (!phone) {
                        setPhone(true);
                        return;
                      }
                      setCustomerData({
                        ...customerData,
                        contact_phone: value || "",
                      });
                      if (!value) {
                        setValidation({
                          ...validation,
                          contact_phone: {
                            ...validation.contact_phone,
                            error: false,
                            skipped: false,
                            message: t.common.required_field,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          contact_phone: {
                            ...validation.contact_phone,
                            error: false,
                            skipped: true,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      } else if (value && !isPhoneValid(value)) {
                        setValidation({
                          ...validation,
                          contact_phone: {
                            ...validation.contact_phone,
                            error: true,
                            skipped: true,
                            message: t.customers.form.invalid_phone,
                            pattern: (phone) =>
                              phone === "" || isPhoneValid(phone),
                          },
                        });
                      }
                    }}
                    error={
                      validation?.contact_phone?.error &&
                      validation?.contact_phone?.skipped
                    }
                  />
                  {validation?.contact_phone?.error &&
                  validation?.contact_phone?.skipped ? (
                    <div className="label-error">
                      {validation?.contact_phone?.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>

                <Form.Field   className="industry-type" >
                  <label className="label-item mt-1">
                    {t.customers.contact_email}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_contact_email}
                    value={customerData.contact_email}
                    onChange={onValuesChange("contact_email")}
                    className="email-password-ltr"
                    error={
                      validation.contact_email.error &&
                      validation.contact_email.skipped
                    }
                    onBlur={makeOnBlur("contact_email")}
                  />
                  {validation.contact_email.error &&
                  validation.contact_email.skipped ? (
                    <div className="label-error">
                      {validation.contact_email.message}
                    </div>
                  ) : (
                    ""
                  )}
                </Form.Field>
              </div>

              <div className={activePane === 1 ? "d-block" : "d-none"}>
                <Form.Field>
                  <label className="label-item mt-7">
                    {t.vendors.form.name}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_name}
                    value={customerData.billing_name}
                    onChange={onValuesChange("billing_name")}
                    error={validation.billing_name.error && validation.billing_name.skipped}
                    onBlur={makeOnBlur("billing_name")}
                  />
                  {validation.billing_name.error && validation.billing_name.skipped ? (
                      <div className="label-error">
                        {validation.billing_name.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field autoComplete="off">
                  <label className="label-item">
                    {t.customers.form.country}
                  </label>
                  <Dropdown
                    placeholder={t.locations.form.country_add}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    clearable
                    search
                    selection
                    options={customerData.countries_options}
                    value={customerData.country}
                    onChange={onValuesChange("country")}
                  />
                </Form.Field>

                <Form.Field autoComplete="off">
                  <label className="label-item">{t.customers.form.city}</label>
                  <Dropdown
                    placeholder={t.locations.form.city_add}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    clearable
                    search
                    selection
                    disabled={customerData.cities_options.length < 1}
                    options={customerData.cities_options}
                    value={customerData.city}
                    onChange={onValuesChange("city")}
                  />
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.postal_code}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_postal}
                    value={customerData.billing_postal_code}
                    onChange={onValuesChange("billing_postal_code")}
                    error={validation.billing_postal_code.error && validation.billing_postal_code.skipped}
                    onBlur={makeOnBlur("billing_postal_code")}
                  />
                  {validation.billing_postal_code.error && validation.billing_postal_code.skipped ? (
                      <div className="label-error">
                        {validation.billing_postal_code.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.address}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_address}
                    value={customerData.billing_address}
                    onChange={onValuesChange("billing_address")}
                    error={validation.billing_address.error && validation.billing_address.skipped}
                    onBlur={makeOnBlur("billing_address")}
                  />
                  {validation.billing_address.error && validation.billing_address.skipped ? (
                      <div className="label-error">
                        {validation.billing_address.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.address_line_2}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_address}
                    value={customerData.billing_addressLine2}
                    onChange={onValuesChange("billing_addressLine2")}
                    error={validation.billing_addressLine2.error && validation.billing_addressLine2.skipped}
                    onBlur={makeOnBlur("billing_address")}
                  />
                  {validation.billing_addressLine2.error && validation.billing_addressLine2.skipped ? (
                      <div className="label-error">
                        {validation.billing_addressLine2.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.customers.form.address_line_3}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.customers.form.add_address}
                    value={customerData.billing_addressLine3}
                    onChange={onValuesChange("billing_addressLine3")}
                    error={validation.billing_addressLine3.error && validation.billing_addressLine3.skipped}
                    onBlur={makeOnBlur("billing_address")}
                  />
                  {validation.billing_addressLine3.error && validation.billing_addressLine3.skipped ? (
                      <div className="label-error">
                        {validation.billing_addressLine3.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">{t.customers.form.rate}</label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    type="number"
                    onKeyDown={(evt) => handleKeyDown(evt)}
                    min="0"
                    placeholder={t.customers.form.add_rate}
                    value={customerData.billing_rate}
                    onChange={onValuesChange("billing_rate")}
                    error={validation.billing_rate.error && validation.billing_rate.skipped}
                    onBlur={makeOnBlur("billing_rate")}
                  />
                  {validation.billing_rate.error && validation.billing_rate.skipped ? (
                      <div className="label-error">
                        {validation.billing_rate.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {" "}
                    {t.customers.form.currency}
                  </label>
                  <Dropdown
                    placeholder={t.customers.form.add_currency}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    search
                    selection
                    clearable
                    options={currencies}
                    value={customerData.billing_currency}
                    onChange={onValuesChange("billing_currency")}
                  />
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.vendors.form.pre_days}
                  </label>
                  <div className="estimation-time-div">
                    <Input
                      type="number"
                      onKeyDown={(evt) => handleKeyDown(evt)}
                      min="0"
                      fluid
                      placeholder={t.vendors.form.add_pre_days}
                      value={customerData.pre_process_days}
                      onChange={onValuesChange("pre_process_days")}
                    ></Input>
                  </div>
                </Form.Field>

                <Divider className="m-0" />

                <div className="billing-info mt-7  d-flex">
                  <BillingInfoIcon />
                  <p

                    className={`font16 mt-1 required-text ${
                      selectedLanguage == "en" ? "ml-2" : "mr-2"
                    }`}
                  >
                    {t.vendors.form.payment_info}
                  </p>
                </div>

                <Form.Field>
                  <label className="label-item mt-7">
                    {t.vendors.form.mode}
                  </label>
                  <Dropdown
                    placeholder={t.vendors.form.add_mode}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    clearable
                    selection
                    search
                    options={options.Mode}
                    value={customerData.mode}
                    onChange={onValuesChange("mode")}
                  />
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.vendors.form.bank}
                  </label>
                  <Input
                    autoComplete="new-password"
                    fluid
                    placeholder={t.vendors.form.add_bank}
                    value={customerData.bank}
                    onChange={onValuesChange("bank")}
                    error={validation.bank.error && validation.bank.skipped}
                    onBlur={makeOnBlur("bank")}
                  />
                  {validation.bank.error && validation.bank.skipped ? (
                      <div className="label-error">
                        {validation.bank.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.vendors.form.account}
                  </label>
                  <Dropdown
                    placeholder={t.vendors.form.add_account}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    clearable
                    selection
                    search
                    options={options.accountType}
                    value={customerData.account_type}
                    onChange={onValuesChange("account_type")}
                  />
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.vendors.form.account_no}
                  </label>
                  <Input
                    type="number"
                    onKeyDown={(evt) => handleKeyDown(evt)}
                    min="0"
                    autoComplete="new-password"
                    fluid
                    placeholder={t.vendors.form.add_account_no}
                    value={customerData.account_no}
                    onChange={onValuesChange("account_no")}
                    error={validation.account_no.error && validation.account_no.skipped}
                    onBlur={makeOnBlur("account_no")}
                  />
                  {validation.account_no.error && validation.account_no.skipped ? (
                      <div className="label-error">
                        {validation.account_no.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item mt-1">
                    {t.vendors.form.IBAN}
                  </label>
                  <Input
                    type="number"
                    onKeyDown={(evt) => handleKeyDown(evt)}
                    min="0"
                    autoComplete="new-password"
                    fluid
                    placeholder={t.vendors.form.IBAN_placeholder}
                    value={customerData.IBAN}
                    onChange={onValuesChange("IBAN")}
                    error={validation.IBAN.error && validation.IBAN.skipped}
                    onBlur={makeOnBlur("IBAN")}
                  />
                  {validation.IBAN.error && validation.IBAN.skipped ? (
                      <div className="label-error">
                        {validation.IBAN.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>

                <Form.Field>
                  <label className="label-item">
                    {t.vendors.form.disbursement_currency}
                  </label>
                  <Dropdown
                    placeholder={t.vendors.form.add_disbursement_currency}
                    noResultsMessage={t.common.no_results_found}
                    fluid
                    search
                    selection
                    clearable
                    options={currencies}
                    value={customerData.disbursement_currency}
                    onChange={onValuesChange("disbursement_currency")}
                    error={validation.disbursement_currency.error && validation.disbursement_currency.skipped}
                    onBlur={makeOnBlur("disbursement_currency")}
                  />
                  {validation.disbursement_currency.error && validation.disbursement_currency.skipped ? (
                      <div className="label-error">
                        {validation.disbursement_currency.message}
                      </div>
                  ) : (
                      ""
                  )}
                </Form.Field>
              </div>
            </div>

            <div
              className={`form-button-container ${
                activePane == 1 ? "mt-8" : "mt-8"
              }`}
            >
              <button
                content={t.common.cancel}
                className="form-action-button"
                basic
                type="button"
                onClick={() =>
                  initChange ? setNewCancelModal(true) : cancelHandler()
                }
              >
                {t.common.cancel}
              </button>
              {activePane == 1 ? (
                <button
                  content={t.common.submit}
                  primary
                  type="button"
                  onClick={createNewCustomerHandler}
                  className="form-action-button blue"
                >
                  {t.common.submit}
                </button>
              ) : (
                <button
                  content={t.common.next}
                  className="form-action-button blue"
                  type="button"
                  primary
                  onClick={() => {
                    changeTab(activePane + 1);
                  }}
                >
                  {t.common.next}
                </button>
              )}
            </div>
          </div>
        </Resizable>
      </div>
      <div
        className={
          toggled ? "aside-modal-background active" : "aside-modal-background"
        }
        onClick={() => (initChange ? setNewCancelModal(true) : cancelHandler())}
      ></div>

      <NewCancelModal
        yesCallback={() => {
          cancelHandler();
        }}
        title={t.parts.form.changes}
      >
        <p className="cancel-child"> {t.common.cancel_2statement}</p>
      </NewCancelModal>
      {toggleAsideModal && (
        <AddLocation
          toggled={toggleAsideModal}
          allIds={allIds}
          role={role}
          currentUserId={currentUserId}
          untoggle={() => {
            setToggleAsideModal(false);
            setToggleAddModal(true);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
          }}
          setRefresh={setRefresh}
          refresh={refresh}
          parentLocation={null}
          fromCustomer={true}
          handleSuccess={async (res) => {
            if (!(role === "super_admin")) {
              setCustomerData({
                ...customerData,
                location: res?.data?.id,
              });

              let updatedAllIds = [...allIds];
              const [userData] = await Promise.all([getUserData(user.id)]);

              dispatch(props.fulfillUser(userData));
              userData?.locations?.length &&
                userData.locations.forEach((location) => {
                  if (!updatedAllIds.some((inv) => inv == location?.id)) {
                    updatedAllIds.push(location?.id);
                  }

                  location.subLocations.forEach((subLocation) => {
                    if (!updatedAllIds.some((inv) => inv == subLocation?.id)) {
                      updatedAllIds.push(subLocation?.id);
                    }
                  });
                });

              setAllIds(updatedAllIds);
              await fetchLocationsOptions(updatedAllIds);
            } else {
              setToggleAsideModal(false);
              setToggleAddModal(true);

              setCustomerData({
                ...customerData,
                location: res?.data?.id,
              });
            }
          }}
        />
      )}
    </>
  );
}

export default connect(null, auth.actions)(Add);
